import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// NMU-473: homepage slider cards — /api/v1/admin/sliders
const SERVICE_NAME = API_PATH.SLIDER;

const search = (condition = {}) => {
    const params = Object.keys(condition)
        .filter((k) => condition[k] !== null && condition[k] !== undefined && condition[k] !== '')
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(condition[k])}`);
    return httpUtils.get(SERVICE_NAME + (params.length ? `?${params.join('&')}` : ''));
};

const getById = (id) => httpUtils.get(`${SERVICE_NAME}/${encodeURIComponent(id)}`);

const add = (bean) => httpUtils.post(SERVICE_NAME, bean);

const edit = (id, bean) => httpUtils.put(`${SERVICE_NAME}/${encodeURIComponent(id)}`, bean);

const remove = (id) => httpUtils.del(`${SERVICE_NAME}/${encodeURIComponent(id)}`);

/** Save a new display order — an array of ids in the order they should appear. */
const reorder = (orderedIds) => httpUtils.put(`${SERVICE_NAME}/reorder`, orderedIds);

const sliderApi = { search, getById, add, edit, remove, reorder };

export default sliderApi;
